const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35.556,
  height: 35.556,
  fill: "none"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_243",
  "data-name": "Group 243",
  transform: "translate(-705 -710)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_207",
  "data-name": "Group 207",
  transform: "translate(-753 467)"
}, /*#__PURE__*/React.createElement("g", {
  id: "question_1_",
  "data-name": "question (1)",
  transform: "translate(1458 242.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_345",
  "data-name": "Path 345",
  d: "M78,39A39,39,0,1,0,39,78,39,39,0,0,0,78,39Z",
  transform: "translate(0 0)",
  fill: "#f99d30"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Cancel",
  transform: "translate(727.443 731)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_3",
  "data-name": "Union 3",
  d: "M17.778,21.01,3.232,35.556,0,32.323,14.545,17.778,0,3.232,3.232,0,17.778,14.545,32.323,0l3.234,3.232L21.01,17.778,35.556,32.323l-3.234,3.234Z",
  fill: "#fff"
})));
function SvgRejectOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.001,
    height: 78,
    viewBox: "0 0 78.001 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectOrange);
export default __webpack_public_path__ + "static/media/reject-orange.7f1075f9bd3c2c43ed83889966e11cf3.svg";
export { ForwardRef as ReactComponent };